
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import EventGuests from '@/modules/admin/events/_components/EventGuests.vue';
  import DlgEventSendEmail from '@/modules/admin/events/_components/DlgEventSendEmail.vue';
  import EventDetails from '@/modules/admin/events/_components/EventDetails.vue';
  import EventTemplates from '@/modules/admin/events/_components/EventTemplates.vue';
  import EventHosts from '@/modules/admin/events/_components/EventHosts.vue';

  @Component({
    components: {
      EventHosts,
      EventTemplates,
      EventDetails,
      DlgEventSendEmail,
      EventGuests,
    },
  })
  export default class VEventDetails extends Vue {
    public $refs!: {
      form: any,
    };

    @Prop({type: String, default: ''}) private id!: string;

    @Action('admin/events/readOne') private readOne!: (params: any) => Promise<any>;
    @Action('admin/groups/read') private readGroups!: () => Promise<any>;

    @Action('common/loader/start') private start!: () => Promise<any>;
    @Action('common/loader/stop') private stop!: () => Promise<any>;

    @Getter('admin/events/one') private event!: any;

    private loading: boolean = false;
    private text: string = '';
    private valid: boolean = true;
    private localEvent: any = null;

    private mounted() {
      return this.init();
    }

    private async init() {
      this.start();
      this.loading = true;
      await this.readOne({id: this.id});

      this.localEvent = this.event;
      this.loading = false;
      this.stop();
    }
  }
